import React, { useState } from 'react';
import { Button } from 'antd';
import logoGif from '../../assets/img/logo.gif';

import './style.scss';

const Header = () => {
  const logout = () => {
    window.localStorage.clear();
    window.location.reload();
  };
  const [isAuthenticated] = useState(window.localStorage.access_token !== undefined);
  return (<div className="header-container">
    <div className="header-container--logo-container">
      <img alt="OAS logo" src={logoGif} />
    </div>
    <div className="title">
      <h2>
        Fortaleciendo las capacidades de las Autoridades Locales en la Recepción e Integración de Migrantes y Refugiados. /
        Strengthening the capacities of Local Authorities in the Reception and Integration of Migrants and Refugees.
      </h2>
    </div>
    <div className="logout-container">
      { isAuthenticated === true &&
        <Button onClick={() => { logout(); }} type="link">Logout</Button>
      }
    </div>
  </div>);
};

export default Header;